// components/LSSF/HealthApplicationsList.jsx
import React from 'react';
import BaseList from './BaseList';

const HealthApplicationsList = () => {
  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'age', label: 'Age' },
    { key: 'id_card_number', label: 'ID Card Number' },
    { key: 'id_card_type', label: 'ID Card Type' },
    { key: 'parent_spouse_name', label: 'Parent/Spouse Name' },
    { key: 'phone', label: 'Phone' },
    { key: 'address', label: 'Address' },
    { key: 'health_issue', label: 'Health Issue' },
  ];

  return (
    <BaseList
      title="Health Camp Applications"
      apiEndpoint="/api/v1/mail/health-camp-form"
      columns={columns}
      addButtonLink="/dashboard/lssf/add-health-application"
      addButtonText="Add Health Application"
    />
  );
};

export default HealthApplicationsList;